<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ label }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">{{ trans('order.periods.' + period) }}</div>
            </div>
        </div>

        <!-- TODO: Make editing of periods possible -->
        <div v-if="renewable && false" class="page-block__item-nav">
            <router-link :to="{ name: '' }">
                <button type="button" class="btn btn--ghost btn--ghost-full-width">
                    {{ renewLabel }}
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        period: {
            type: Number,
            required: true
        },
        periodSuffix: {
            type: String,
            required: true
        },
        renewable: {
            type: Boolean
        },
        renewLabel: {
            type: String
        }
    }
};
</script>
